export default __webpack_public_path__ + "static/media/359.e199e2f0.gif";